export default "__VITE_PUBLIC_ASSET__fb851b2f__"